import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import './Signup.css';
import { API_ENDPOINTS } from './apiConfig';
import { useNavigate } from 'react-router-dom';

const BASE_IMG_URL = API_ENDPOINTS.BASEIMGURL;


function DisplayProfileImages() {
  const { token } = useAuth();
  const [images, setImages] = useState([]);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedImg, setSelectedImg] = useState(null);
const navigate = useNavigate();
  useEffect(() => {
    fetchImages();
  }, []);

  useEffect(() => {
  if (!token || token.trim() === '') {
    navigate('/login');
  }
}, [token, navigate]);

  const fetchImages = async () => {
    try {
      const res = await axios.post(`${API_ENDPOINTS.GETDETAILS}`, {}, {
        headers: { token },
      });
      if (res.data.result === 1) {
        setImages(res.data.data.Img || []);
      } else {
        setErrors(['Failed to load images.']);
      }
    } catch (error) {
      setErrors(['Error fetching images.']);
    }
  };

  const confirmDelete = (imgPath) => {
    setSelectedImg(imgPath);
    setShowModal(true);
  };

  const handleDeleteConfirmed = async () => {
    if (!selectedImg) return;
    const imageName = selectedImg.split('/').pop();
    setLoading(true);

    try {
      const res = await axios.post(`${API_ENDPOINTS.DELETEPHOTO}`, { id: imageName }, {
        headers: { token },
      });

      if (res.data.result === 1) {
        setImages((prev) => prev.filter((img) => img.Path !== selectedImg));
        setShowModal(false);
        setSelectedImg(null);
      } else {
        setErrors(['Failed to delete image.']);
      }
    } catch (err) {
      setErrors(['Error deleting image.']);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{ background: 'linear-gradient(135deg, #ffe0f0, #d0e8ff)', paddingTop: '4rem' }}
    >
      <div style={{ maxWidth: 480, width: '100%', margin: '0 auto' }}>
       

<div className="text-center mb-4">
  <h6 className="mt-2" style={{ color: '#d63384', fontWeight: 500 }}>
  Your Profile Photos
</h6>
  <a
    href="/ProfileImageUpload"
    className="btn btn-sm d-inline-flex align-items-center mt-2"
    style={{
      backgroundColor: '#ff69b4',
      color: 'white',
      fontSize: '0.8rem',
      padding: '6px 12px',
      borderRadius: '20px',
    }}
  >
    <i className="bi bi-upload me-1"></i> Upload More
  </a>
</div>



        {images.length === 0 && <p className="text-center text-muted">No images uploaded.</p>}

        <div className="d-flex flex-wrap gap-3 justify-content-center">
          {images.map((img, idx) => (
            <div
              key={idx}
              className="position-relative border rounded shadow-sm"
              style={{ width: 100, height: 100 }}
            >
              <img
                src={BASE_IMG_URL + img.Path}
                alt={`User ${idx}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 8,
                }}
              />
              <button
                type="button"
                className="btn btn-sm btn-outline-danger position-absolute top-0 end-0 m-1 p-1"
                onClick={() => confirmDelete(img.Path)}
                style={{
                  borderRadius: '50%',
                  width: '26px',
                  height: '26px',
                  fontSize: '0.75rem',
                }}
              >
                <i className="bi bi-trash3-fill"></i>
              </button>
            </div>
          ))}
        </div>

        {/* Bootstrap Confirmation Modal */}
        <div className={`modal fade ${showModal ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="bi bi-exclamation-triangle-fill text-danger me-2"></i>
                  Confirm Delete
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center">
                <p>Are you sure you want to delete this image?</p>
                <img
                  src={BASE_IMG_URL + selectedImg}
                  alt="To delete"
                  className="img-fluid rounded mb-2"
                  style={{ maxHeight: '200px' }}
                />
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => setShowModal(false)}
                  disabled={loading}
                >
                  <i className="bi bi-x-circle me-1"></i> Cancel
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={handleDeleteConfirmed}
                  disabled={loading}
                >
                  <i className="bi bi-trash3 me-1"></i> {loading ? 'Deleting...' : 'Delete'}
                </button>
              </div>
            </div>
          </div>
        </div>

        {errors.length > 0 && (
          <div className="alert alert-danger mt-3">
            <ul className="mb-0">{errors.map((e, i) => <li key={i}>{e}</li>)}</ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default DisplayProfileImages;
